<template>
  <div
    class="sectionContainer"
    :class="[
      {
        'sectionContainer--disableBottomMargin': disableBottomMargin,
        'sectionContainer--smallCenterTitle': smallCenterTitle,
        'sectionContainer--disableWhiteBackground': disableWhiteBackground,
      },
    ]"
  >
    <div v-if="title || smallTitle" class="sectionContainer__header">
      <div>
        <div v-if="smallTitle" class="sectionContainer__smallTitle">
          {{ smallTitle }}
        </div>
        <h2
          v-if="title"
          :class="['sectionContainer__title', { 'sectionContainer__title--big': smallTitle }]"
        >
          {{ title }}
        </h2>
      </div>
      <div v-if="link">
        <BorderLink :to="link.path" :text="link.title" />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import BorderLink from '@/components/BorderLink';

export default {
  name: 'SectionContainer',
  components: { BorderLink },
  props: {
    title: {
      type: String,
      default: '',
    },
    link: {
      type: Object,
      default: () => {},
    },
    disableWhiteBackground: {
      type: Boolean,
      default: false,
    },
    productName: {
      type: String,
      default: '',
    },
    disableBottomMargin: {
      type: Boolean,
      default: false,
    },
    smallTitle: {
      type: String,
      default: '',
    },
    smallCenterTitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.sectionContainer {
  $root: &;
  margin-bottom: 1.6rem;
  background-color: $cWhite;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2.2rem 3rem 0 2rem;

    @include rwd('tablet') {
      padding: 2rem 2rem 0 2rem;
      flex-direction: column;
      margin-bottom: 2rem;
      align-items: unset;
    }
  }

  &__smallTitle {
    font-size: 1.8rem;
    line-height: 1.5;
    color: $cAddDark02;
    font-weight: 500;
    margin-bottom: 1rem;
  }

  &__title {
    display: block;
    font-size: 2.8rem;
    line-height: 3.5rem;
    font-weight: 600;

    @include rwd('tablet') {
      margin-bottom: 1rem;
    }

    @include rwd('small-tablet') {
      font-size: 2.4rem;
      line-height: 3.4rem;
      text-align: center;
    }

    &--big {
      font-size: 4.8rem;
      line-height: 1.1;
      font-weight: 500;
      margin-bottom: 1.8rem;
      max-width: 70rem;

      @include rwd('large-tablet') {
        font-size: 3.6rem;
        margin-bottom: 0;
      }

      @include rwd('tablet') {
        font-size: 2.8rem;
      }

      @include rwd('small-tablet') {
        text-align: left;
      }
    }
  }

  &--disableWhiteBackground {
    background: transparent;

    #{$root}__header {
      padding: 2.2rem 0 0 0;

      @include rwd('tablet') {
        padding: 2rem 0 0 0;
      }
    }
  }

  &--disableBottomMargin {
    margin-bottom: 0;
  }

  &--smallCenterTitle {
    #{$root}__header {
      justify-content: center;
    }

    #{$root}__title {
      text-align: center;
      font-size: 2rem;
      line-height: 1.2;
    }
  }
}
</style>
